import controller from './upload-cpe.controller.js';

let uploadCPEModule = angular.module('upload-cpe', [])

    .directive('uploadCpe', () => {
        'ngInject';

        return {
            retrict: 'EA',
            controller: controller,
            controllerAs: '$ctrl',
            scope: {
                validColumns: '@',
                rowThreshold: '@',
                dateFormat: '@',
                eventStartDateRange: '@',
                qualifyingActivity: '@',
                methodofDelivery: '@',
                isacaMemberNumberDigits: '@',
                cpeHours: '@'
            },
            bindToController: true,
            transclude: true,
            link: (scope, element, attrs, ctrlr, transclude) => {
                transclude(scope, (clone, scope) => {
                    element.append(clone);
                });
            }
        };
    })

    .name;

export default uploadCPEModule;



// WEBPACK FOOTER //
// ./src/app/angular/upload-cpe/upload-cpe.js